import { useQuery } from '@tanstack/react-query';

import { fetchExtractedDataFromPolicy } from '@/policy/api/FetchPolicy';

export const useFetchExtractedDataFromPolicy = (uuid: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['policy', uuid],
    queryFn: () => fetchExtractedDataFromPolicy(uuid),
  });

  return {
    policy: data,
    isLoading,
    error,
  };
};
